import { Link } from "react-router-dom";
import logo from "@/assets/logo.png";

export function SiteFooter() {
  return (
    <footer className="relative border-t border-border/30 bg-card/20">
      {/* Signature traffic-light divider */}
      <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center gap-1.5 bg-background px-4">
        <span className="h-2 w-2 rounded-full bg-success" />
        <span className="h-2 w-2 rounded-full bg-warning" />
        <span className="h-2 w-2 rounded-full bg-danger" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 pb-10 pt-10">
        <div className="flex flex-col items-center gap-6 text-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 hover:opacity-80 transition-opacity">
            <img src={logo} alt="Memo" className="h-8 w-8 rounded-xl" />
            <span className="text-lg font-semibold text-foreground">Memo</span>
          </Link>

          {/* Nav links */}
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <Link to="/pricing" className="hover:text-foreground transition-colors">
              Pricing
            </Link>
            <Link to="/how-it-works" className="hover:text-foreground transition-colors">
              How it works
            </Link>
            <Link to="/auth" className="hover:text-foreground transition-colors">
              Sign in
            </Link>
          </div>

          {/* Copyright */}
          <p className="text-xs text-muted-foreground">
            © 2026 Memo · Built for Indian founders.
          </p>

          {/* BWE Studio credit — signature style */}
          <a
            href="https://bwestudios.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-all"
          >
            <span className="text-xs tracking-wide uppercase">Crafted by</span>
            <span className="font-bold text-foreground group-hover:text-accent transition-colors">
              BWE Studio
            </span>
            <svg
              className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 12L12 4M12 4H6M12 4V10" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
